// ~/plugins/swiper.js
import {Swiper, SwiperSlide} from 'swiper/vue'
import {EffectCards, Mousewheel, Autoplay, EffectCreative} from 'swiper/modules'
import {defineNuxtPlugin} from '#app'
import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/effect-cards'
import 'swiper/css/effect-creative'
import 'swiper/css/pagination'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.component('Swiper', Swiper)
  nuxtApp.vueApp.component('SwiperSlide', SwiperSlide)
})
